module.exports = __webpack_public_path__ + "static/media/congrats-icon.48a4681b.svg";